import Vue from "vue";
import VueI18n from "vue-i18n";

import moment from "moment";
moment.locale(window.AcademIt.Locale);

import numeral from "numeral";
import "numeral/locales/ru";
numeral.locale(window.AcademIt.Locale);

import translations from "@/resources";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: window.AcademIt.Locale,
    messages: translations
});

export default i18n;